import React from 'react';

import { ExportSeaWaybill as ExportSeaWaybillImpl } from '@components/utilities/BookingInquiry/ExportSeaWaybill';

export const ExportSeaWaybill: React.FC = () => {
  return <ExportSeaWaybillImpl />;
};
